<template>
  <v-app>
    <AppDrawer />
    <v-app-bar app clipped-left color="white">
      <div class="d-flex align-center">
        <v-img
          alt="Nexus Connect Logo"
          class="shrink mr-2 ml-5"
          contain
          src="@/assets/nexus-connect-logo.svg"
          transition="scale-transition"
        />
      </div>

      <v-spacer></v-spacer>
    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import { mapActions } from "vuex";
import AppDrawer from "./components/AppDrawer.vue";
import client from "./lib/ApiClient";

export default {
  name: "App",

  components: {
    AppDrawer,
  },

  data: () => ({
    accessToken: null,
    loading: true,
  }),

  methods: {
    ...mapActions(["loadData"]),
    async initializeApplication(accessToken) {
      this.accessToken = accessToken;

      this.$axios.defaults.headers.Authorization = `Bearer ${accessToken}`;
      await this.loadData();
      this.loading = false;
      if (this.$route.path === "/callback")
        this.$router.push({ name: "dashboard" });
    },
    fetchURLParam(param) {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      if (urlParams.has(param)) {
        return urlParams.get(param);
      }
      return false;
    },
  },
  beforeMount() {
    let accessToken = this.$cookies.get("osteonAccessToken");
    if (accessToken) {
      this.initializeApplication(accessToken);
    } else {
      accessToken = this.fetchURLParam("access_token");
      const expiresInSecs = this.fetchURLParam("expires_in");
      const expiresInMSecs = expiresInSecs * 1000;
      const expiresAt = new Date(new Date().getTime() + expiresInMSecs);
      if (accessToken && expiresAt) {
        this.$cookies.config(expiresAt);
        this.$cookies.set("osteonAccessToken", accessToken);
        this.initializeApplication(accessToken);
      } else {
        client.auth.redirectToID();
      }
    }
  },
};
</script>
